export interface CalendarDay {
    date: string;   // ISO 'yyyy-MM-dd'
    day: number;    // day-of-month
    inMonth: boolean;
}

export function toIso(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

export function fromIso(s: string): Date {
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y, m - 1, d);
}

/** 42-cell (6-week) grid for the month containing `monthAnchorIso`. Week starts Monday. */
export function buildMonthGrid(monthAnchorIso: string): CalendarDay[] {
    const anchor = fromIso(monthAnchorIso);
    const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
    const offset = (first.getDay() + 6) % 7; // Monday=0 … Sunday=6
    const start = new Date(first);
    start.setDate(first.getDate() - offset);
    const days: CalendarDay[] = [];
    for (let i = 0; i < 42; i++) {
        const d = new Date(start);
        d.setDate(start.getDate() + i);
        days.push({ date: toIso(d), day: d.getDate(), inMonth: d.getMonth() === anchor.getMonth() });
    }
    return days;
}

/** Inclusive range check. ISO 'yyyy-MM-dd' strings compare correctly lexically. */
export function isInRange(iso: string, start: string | null, end: string | null): boolean {
    if (!start || !end) return false;
    return iso >= start && iso <= end;
}

export function addMonths(monthAnchorIso: string, delta: number): string {
    const d = fromIso(monthAnchorIso);
    return toIso(new Date(d.getFullYear(), d.getMonth() + delta, 1));
}
